<template>
<authentication>
  <!-- Only override text for passwordless auth by using `v-if`. -->
  <template
    v-if="method === 'passwordless'"
    slot="title"
    slot-scope="{ method, stage }"
  >{{
    (function() {
      switch (stage) {
      case 'passwordless.phone': return 'Введите номер';
      case 'passwordless.code': return 'Введите SMS-код';
      default: throw new Error(`Unrecognized auth stage ${stage}`);
      }
    })()
  }}</template>
  <template
    v-if="method === 'passwordless'"
    slot="subtitle"
    slot-scope="{ method, stage, login }"
  >{{
    (function() {
      switch (stage) {
      case 'passwordless.phone':
        return 'Для оформления заказа укажите номер телефона,\nмы отправим на него проверочный код';
      case 'passwordless.code': return `Мы отправили SMS-код на ваш номер\n${login}`;
      }
    })()
  }}</template>
</authentication>
</template>

<script>
import Authentication from '@/components/auth/Authentication'

export default {
  components: {
    Authentication,
  },
}
</script>
